<!--
 * @Date: 2020-09-03 15:15:45
 * @Author: MX
 * @LastAuthor: WZ
 * @LastEditTime: 2020-12-25 17:22:30
 * @Description: 接口管理
-->
<template>
  <div class="interfaceManage">
    <el-collapse v-model="activeName">
      <el-collapse-item v-for="item in tableList" :title="$lang(item.title)" :name="item.value" :key="item.value">
        <template #title v-if="item.value != 1">
          <p>
            {{ $lang(item.title)
            }}<span class="title_sub">{{$lang('接口申请后，请等待1-2个工作日审核')}}</span>
          </p>
        </template>
        <el-table border :data="filterData[item.value]" style="width: 100%;border-radius:4px;">
          <el-table-column type="index" :label="$lang('序号')" align="center" width="100">
          </el-table-column>
          <el-table-column prop="name" align="center" :label="$lang('API名称')">
            <template slot-scope="{ row }">
              {{ $lang(row.name) }}
            </template>
          </el-table-column>
          <el-table-column prop="detail" :show-overflow-tooltip="true" align="center" :label="$lang('说明')">
          </el-table-column>
          <el-table-column prop="status" align="center" :label="$lang('状态')">
            <template slot-scope="{ row }">
              {{ row.status | statusFilter }}
            </template>
          </el-table-column>
          <el-table-column v-if="item.value == 1" prop="updatedTime" align="center" :label="$lang('上线时间')" width="180">
          </el-table-column>
          <el-table-column v-if="status == 1" prop="urlCallback" align="center" label="URL" :show-overflow-tooltip="true">
          </el-table-column>

          <el-table-column align="center" :label="$lang('操作')">
            <template slot-scope="{ row }">
              <el-button v-if="allowApply && row.status === 2" type="text" @click="stopUse(row.id)">{{$lang('停用')}}</el-button>
              <el-button v-if="allowApply && row.status !== 1 && row.status !== 2" type="text" @click="apply(row)">{{$lang('申请')}}</el-button>
              <el-button v-if="allowApply && status == 1 && row.status != 0 && row.status != 3" type="text" @click="apply(row)">{{$lang('修改')}}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-collapse-item>
    </el-collapse>

    <el-dialog :title="$lang('接口信息')" class="editData" :visible.sync="dialogVisible" width="35%" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form label-position="top" :model="editFormData" ref="editData" :rules="editFormDataRule" label-suffix="：">
        <el-row :gutter="15">
          <el-col :span="8">
            <el-form-item :label="$lang('API名称')">
              {{editFormData.name}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$lang('说明')">
              <p style="line-height:20px">{{editFormData.detail}}</p>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="URL" prop='urlCallback'>
              <el-input v-model.trim="editFormData.urlCallback" :placeholder="$lang('请输入')"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{$lang('返回')}}</el-button>
        <el-button type="primary" @click.native="save">{{$lang('保存')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script type="text/javascript">
import { RESPONSE_SUCCESS } from "@/constants";
import { RULES } from '@/constants/rules'
import { mapGetters } from "vuex";
import {lang} from "@utils/filters"
export default {
  name: "InterfaceManage",
  props: {
    // 是否允许开发者申请api
    allowApply: {
      type: Boolean,
      default: false,
    },
    status: {
      type: [Number, String],
      default: 0,
    },
  },
  components: {},
  filters: {
    //过滤器的配置项
    statusFilter: function(val) {
      const arr = ["未申请", "申请中", "已上线", "停用"];
      return lang(arr[val]);
    },
  },
  data() {
    return {
      activeName: ["1", "2", "3"],
      tableList: [
        { title: "已上线", value: "1" },
        { title: "申请中", value: "2" },
        { title: "未上线", value: "3" },
      ],
      dataList: [],
      dialogVisible:false,
      editFormData:{},
      editFormDataRule:{
        urlCallback:[
            { required: true, message: lang('请输入URL'), trigger: 'blur' },
            RULES.url
          ]
      },
      detailOption: {
        '快递轨迹查询': this.$t('onlineDoc.trackDescription_1'),
        '新增订单': this.$t('onlineDoc.OrderDescription_1'),
        '取消订单': this.$t('onlineDoc.OrderDescription_3'),
        '查询订单': this.$t('onlineDoc.OrderDescription_2'),
        '打印订单': this.$t('onlineDoc.OrderDescription_6'),
        '物流轨迹订阅（新）': this.$t('onlineDoc.trackDescription_2_1'),
        '物流轨迹回传': this.$t('onlineDoc.trackDescription_3'),
        '订单状态回传': this.$t('onlineDoc.OrderDescription_4'),
        '退回件申请': this.$t('onlineDoc.OrderDescription_7'),
        '获取三段码': this.$t('onlineDoc.OrderDescription_8'),
      }
    };
  },
  computed: {
    ...mapGetters(["user"]),
    filterData() {
      return {
        //   状态-0:未申请，1：已申请,2:已上线3：停用
        1: this.dataList.filter(
          (item) => item.status === 2 && item.interfaceType == this.status
        ),
        2: this.dataList.filter(
          (item) => item.status === 1 && item.interfaceType == this.status
        ),
        3: this.dataList.filter(
          (item) =>
            item.status !== 1 &&
            item.status !== 2 &&
            item.interfaceType == this.status
        ),
      };
    },
  },
  mounted() {
    this.getList();
  },
  methods: {
    /**
     * @description 获取列表
     */
    getList() {
      this.$API.getInterfaceList().then((res) => {
        if (res.code === RESPONSE_SUCCESS) {
          const dataList = [...res.data]
          // 先更改描述，根据name去判断，再翻译name
          dataList.map((currentValue,index,arr)=>{
            arr[index] = {...arr[index], detail:this.detailOption[currentValue.name], name:this.$t(currentValue.name)}
          })
          this.dataList = [...dataList]
          console.log(this.dataList)
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    /**
     * @description 申请
     */
    apply(row) {
      if (this.status == 1) {
        this.editFormData = JSON.parse(JSON.stringify(row));
        this.dialogVisible = true;
      } else {
        this.applySubmit({ id:row.id, userId: this.user.id,status:1 })
      }
    },
    /**
     *  停用
     */
    stopUse(id) {
      const formData = new FormData();
      Object.keys({ id }).forEach((key) => {
        formData.append(key, id);
      });
      this.$API.stopUse(formData).then((res) => {
        if (res.code === RESPONSE_SUCCESS) {
          this.$message.success(this.$lang("停用成功"));
          this.getList();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    /**
     * 申请提交
     **/
    applySubmit(param){
      if(param.status == 0 || param.status == 3){
        //申请 停用时
        param.status = 1;//申请中
      }
        this.$API.apply(param).then((res) => {
          if (res.code === RESPONSE_SUCCESS) {
            this.$message.success(this.$lang("保存成功"));
            this.dialogVisible = false;
            this.getList();
          } else {
            this.$message.error(res.msg);
          }
        }).catch(err=>{
          if(err.msg){this.$message.error(err.msg)}else{
            this.$message.error(this.$lang('网络繁忙，请重试'))
          }
        });
    },
    /**
    * 弹出层保存
    */
    save(){
      this.$refs['editData'].validate((valid) => {
          if (valid) {
          this.applySubmit({ id:this.editFormData.id, userId: this.user.id,urlCallback:this.editFormData.urlCallback,status:this.editFormData.status})
          } else {
            console.log('error submit!!');
            return false;
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.editData::v-deep{
  .el-dialog{
    border-radius: 10px;
  }
  .el-form-item .el-form-item__label {
    color: #9499A3;
    padding: 0;
    line-height: 24px
  }
}
  .interfaceManage::v-deep {
    .editData .el-input {
      width: 100%;
    }
    .title_sub {
      font-size: 12px;
      color: #888888;
      font-weight: 400;
      margin-left: 10px;
    }
    .el-collapse {
      border: none;
    }
    .el-collapse-item__wrap {
      border: none;
    }
    .el-collapse-item__header {
      background: #f9fafc;
      margin-bottom: 10px;
      border: 1px solid $table-border-color;
      border-radius: 4px;
      padding-left: 12px;
      font-weight: 600;
    }
    .el-table .has-gutter th {
      background: #f9fafc;
    }
  }
</style>
